import { FunctionComponent, ReactNode, useState } from "react";
import TextFieldAtom from "../../../atoms/textfield";
import {
  LabelPairedCircleXmarkSmFillIcon,
  LabelPairedSearchSmBoldIcon,
} from "@deriv/quill-icons";
import { hasInputValue } from "../../../helpers";

export type SearchFieldType = {
  id?: string;
  name?: string;
  className?: string;
  label?: string;
  placeholder?: string;
  showCharacterCounter?: boolean;
  message?: string;

  /** Variant props */
  indicator?: "neutral" | "fail" | "success";
  state?: "default" | "disabled";
  type?: "outline" | "fill";
  size?: "lg" | "md" | "sm";
  textAlignment?: "left" | "center";

  /** Custom props */
  iconLeft?: ReactNode;
  iconRight?: ReactNode;
  iconStatus?: ReactNode;
  isRequired?: boolean;
  optionalText?: string;
  maxLength?: number;
  value?: string | number;
  onChange?: (value: string | number) => void;
  inputType?: "text" | "password" | "number" | "email" | "tel" | "url";
  messages?: {
    text: string;
    type: "neutral" | "fail" | "success";
    icon?: ReactNode;
  }[];
};

export const SearchField: FunctionComponent<SearchFieldType> = (props) => {
  const [value, setValue] = useState(props.value);
  return (
    <TextFieldAtom
     labelLeft={props.label}
      placeholder={"Search"}
      {...props}
      iconLeft={<LabelPairedSearchSmBoldIcon />}
      iconRight={
        hasInputValue(value) && (
          <LabelPairedCircleXmarkSmFillIcon
            className="quill-ui-next-pointer"
            onClick={() => {
              setValue("")
              props.onChange?.("")
            }}
          />
        )
      }
      onChange={(e: string | number) => {
        setValue(e);
        props.onChange?.(e);
      }}
      variant="labelless"
      value={value}
      showStatusIcon={false}
    />
  );
};

export default SearchField;
